import React, { useState } from 'react';
import { GodDigitalSystem } from './GodDigitalSystem';
import { WelcomeScreen } from './components/WelcomeScreen';
export function App() {
  const [user, setUser] = useState<string | null>(null);
  if (!user) {
    return <WelcomeScreen onEnter={name => setUser(name)} data-id="element-0" />;
  }
  return <GodDigitalSystem data-id="element-1" />;
}